import React from 'react';
import SaleOrderDetail from 'components/Tvendo/Sale/Operations/SaleOrder/SaleOrderDetail';

export default function () {
  return <SaleOrderDetail />;
}
